import { render, staticRenderFns } from "./configurationTemplate.vue?vue&type=template&id=1f90b51c&scoped=true"
import script from "./configurationTemplate.vue?vue&type=script&lang=js"
export * from "./configurationTemplate.vue?vue&type=script&lang=js"
import style0 from "./configurationTemplate.vue?vue&type=style&index=0&id=1f90b51c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90b51c",
  null
  
)

export default component.exports